import React, { useState } from 'react'
import { AddTocartButton } from './AddTocartButton';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const ProductQuickView = ({ product }) => {
    const [quantity, setQuantity] = useState(1);
    console.log(product);
    
    return (
        <div>
            <div className="max-w-5xl mx-auto p-6 grid md:grid-cols-2 gap-6">
                {/* Hình ảnh */}
                <div className="flex justify-center items-center border rounded-lg overflow-hidden">
                    <img
                        src={product?.image?.url}
                        alt="Corny Bar"
                        className=" w-auto h-auto object-cover"
                    />
                </div>

                {/* Thông tin sản phẩm */}
                <div>
                    <h1 className="text-xl font-semibold mb-2">
                        {product?.name}
                    </h1>

                    <div className="flex items-center gap-2 flex-wrap mb-4 w-full">
                        <span className="flex w-1/3 xl:w-auto text-sm xl:text-base font-bold text-red-600">
                            ${product?.price?.toFixed(2)}
                        </span>
                        {product?.oldPrice && <span className="flex  w-1/3 xl:w-auto text-sm line-through text-gray-400">
                            ${product?.oldPrice?.toFixed(2)}
                        </span>}
                        {product?.discount && <span className="flex justify-center  xl:w-auto bg-green-600 text-white text-xs px-[5px] py-[1px] rounded-md">
                            {product?.discount}%
                        </span>}
                    </div>

                    <p className="text-gray-600 text-sm mb-2">
                        Shipping calculated at checkout.
                    </p>

                    <ul className="text-sm text-gray-700 mb-4 space-y-3">
                        <li>
                            <b>Type:</b> Chocolate
                        </li>
                        <li>
                            <b>SKU:</b> SKU14
                        </li>
                        <li>
                            <b>Tags:</b> Chocolates, Food
                        </li>
                        <li>
                            <b>Collections:</b> Dairy Items, Milk, Milk Items, Our Store, Trending Collection
                        </li>
                        <li>
                            <b>Có sẵn:</b>{" "}
                            <span className="text-red-500 font-semibold">{product?.countInStock?.toFixed(0)}</span>
                        </li>
                    </ul>

                    {/* Số lượng */}
                    <div className="flex items-center mb-4">
                        <span className="mr-3 font-medium text-sm">Số lượng</span>
                        <div className="flex items-center border rounded">
                            <button
                                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                                className="px-2 py-1"
                            >
                                -
                            </button>
                            <input
                                type="text"
                                value={quantity}
                                readOnly
                                className="w-12 text-center border-l border-r"
                            />
                            <button
                                onClick={() => setQuantity(quantity + 1)}
                                className="px-2 py-1"
                            >
                                +
                            </button>
                        </div>
                    </div>

                    {/* Nút hành động */}
                    <div className="flex gap-3">
                        <AddTocartButton product={product} quantity={quantity} hover={2} />
                        {/* <button className="bg-yellow-400 text-black px-5 py-2 rounded font-medium hover:bg-yellow-500">
                            Buy it now
                        </button> */}
                    </div>

                    <div className="mt-4">
                        <Link to={`/products/${product?._id}`} className="text-sm text-gray-600 underline">
                            View full details →
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ProductQuickView;